import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/records/$recordId/workspace/assets/$assetId/_drawer/attachments",
)({
	beforeLoad: ({ location }) => {
		throw redirect({
			href: `${location.pathname.replace(/\/attachments\/?$/, "/details")}${location.searchStr ?? ""}${location.hash ?? ""}`,
			replace: true,
		});
	},
});
